import type { FaireProductEntity } from "../../entity_types/product";

export const p_n5sh7c4r4r: FaireProductEntity = {
  token: "p_n5sh7c4r4r",
  type: "product",
  name: "Canton Open Knit Drop Shoulder Sweater Cardigan",
  brandToken: "b_axnmezu6gc",
  brandName: "Suhkasana",
  imageUrl:
    "https://cdn.faire.com/fastly/f3392bc40eacac39b7fcb48b23dd5e2e018c36cfb4506eb910cc03a0bd9b69f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8771f696627f11910e5e20c9e608014e0f3d0c3870c9659f04dba03d2c8cafc6.jpeg",
    "https://cdn.faire.com/fastly/3b090c751ca5db57fdc178016bbd556daba37cb55f348364f5e02adf6fb9d17c.jpeg",
    "https://cdn.faire.com/fastly/4db4b2eca9d5451d88daaddeb56a6c1b51a9fc5042270c14128263d3faf43226.jpeg",
    "https://cdn.faire.com/fastly/c7ebddff2c1cf01a53f92844ac8c57f1ac0d91100be08df4774e441637ea96cc.jpeg",
    "https://cdn.faire.com/fastly/80d6435cd716ab5b23b04ce3b8bca86acc8cc8dad1bb3ea1e1bf3101c0c374e5.jpeg",
    "https://cdn.faire.com/fastly/e6382252cb24c2dceb1211003886f6df5275b79a8d84fbfc7167394406ccef57.jpeg",
    "https://cdn.faire.com/fastly/2de94d9638598aecf1773d6c46ef280367ba94927dbea3e259ef4bd84ab6ae11.jpeg",
    "https://cdn.faire.com/fastly/1d8ed6d54b7079638ebb0b87b65a0c92c0548726c1c7de7a746d25bcaf73e2f8.jpeg",
    "https://cdn.faire.com/fastly/f9669024b4c65d84c2ed5226ad177075e10b0a246ae1258ac4ab3595df9c1e2f.jpeg",
    "https://cdn.faire.com/fastly/d7c19c2998dbb9025d5be7e98f7f6424518023dd18f4ed348cb871335dd60e77.jpeg",
    "https://cdn.faire.com/fastly/53ba8bb078e03304882c276ba97fbec3131f87f0a63331e5df828548a6c21052.jpeg",
    "https://cdn.faire.com/fastly/4828a671272c27d61f75c9ce95cb7fc8337dc786d7b229a7ad7f27dd2eb85b7d.jpeg",
    "https://cdn.faire.com/fastly/c3e0f4f236d30a6130b5323b2d08526e7b2a16486c184b77abb2ab6670a0bfe6.jpeg",
    "https://cdn.faire.com/fastly/7015873baa07c20d7a4d848731515cc9614b647426b03a6e1418336e899f60c4.jpeg",
    "https://cdn.faire.com/fastly/d78971df03b6142856200b4dd1e047f541cc3fe484a1a1bf9d7572dd51eb0803.jpeg",
    "https://cdn.faire.com/fastly/19f1c3a35f56cc7fe77319aca5d5210a568c27eda737ce3424d16411c9f3c2da.jpeg",
    "https://cdn.faire.com/fastly/eef9c916d6924d6dc81f589e6a4331e5a57ad71bf81408df5275bcbf14d9ac51.jpeg",
    "https://cdn.faire.com/fastly/990db9e01513a34db28ab01f05fcbc4b39b394688c071885b661e6ea8f8530a0.jpeg",
    "https://cdn.faire.com/fastly/86688c4d394b53171de9cb241652d549a840f8479638d70da94c76b1ebecfedc.jpeg",
    "https://cdn.faire.com/fastly/fe1faf8a89d5e608cc68db1fde195da46b347ed20e52473afb33f203248d35fe.jpeg",
    "https://cdn.faire.com/fastly/2b8b3b96f364534b45e5d1ded52114569cf3edebcc462484de07f134b33fcea3.jpeg",
    "https://cdn.faire.com/fastly/3dfca09d1c1f3dfcfa9cacbd3939ed9c5ce31ef3257cc9616f4fa1a14d61d13b.jpeg",
    "https://cdn.faire.com/fastly/10751127facf490eed704028c905db1412b04a6577477b0f8504c4f3903c5519.jpeg",
    "https://cdn.faire.com/fastly/95535362d97a57195c9534b9417781238dc95d12467b7a198f2ed3ffd899a811.jpeg",
    "https://cdn.faire.com/fastly/1bbf8d6175e321a5f50ce8f493c1e2874bdfb6730a21410a296f2efc8df23511.jpeg",
    "https://cdn.faire.com/fastly/829a93faab9c76a33fbf7f6a2b73632650caa81eb6d31322466d5f533ac717c5.jpeg",
    "https://cdn.faire.com/fastly/e9d6910f10042778a572255d0398448d0358ecef6fad907a6dc400862d5260d6.jpeg",
    "https://cdn.faire.com/fastly/0b04b7f3e228df73bd41f63a60954d346eb136bba0436ae89774bd3e08a4677f.jpeg",
  ],
  priceDollars: 30.39,
  description:
    "Effortlessly stylish open knit sweater with a graceful style.\nChic slouchy drop shoulder silhouette loved by modern ladies.\nVersatile sweater cardigan with buttons is perfect for layering.\nSoft and cozy fabric for all-day wear and different occasions.\n\nBrand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_mbyt838sy8",
  tags: [],
  msrpDollars: 60.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:12.885Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
